"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function SquareWeddingPrograms(params) {
  var quantity = getValueOfKeyMatching(params, /multi_quantity/);
  var acc_ribbon = getValueOfKeyMatching(params, /acc_ribbon/);
  var backside_printing = parseBoolean(getValueOfKeyMatching(params, /programWording/)) || parseBoolean(getValueOfKeyMatching(params, /REPRINT_program_style/));
  this.personalization.push({
    name: 'Names, Date, Location',
    value: params.pers_programFrontPanel
  });
  this.personalization.push({
    name: 'Wedding Party',
    value: params.pers_programMiddlePanel
  });
  this.personalization.push({
    name: 'Ceremony',
    value: params.pers_programThirdPanel
  });
  this.personalization.push({
    name: 'Additional Wording',
    value: params.pers_programWording
  });
  this.squarePrograms.add({
    quantity: quantity,
    acc_ribbon: acc_ribbon,
    backside_printing: backside_printing
  });
}

module.exports = SquareWeddingPrograms;